import { Sparkles, Workflow } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { formatSignedCurrency, formatDateShort } from "@/utils/format";
import { confidenceLabel } from "@/components/ClassifySuggestion";

const STATUS_META = {
  pending: { label: "Pendiente", cls: "bg-amber-100 text-amber-700" },
  classified: { label: "Clasificado", cls: "bg-blue-100 text-blue-700" },
  reconciled: { label: "Conciliado", cls: "bg-emerald-100 text-emerald-700" },
};

export function suggestionLabel(suggestion, categories) {
  if (!suggestion) return "";
  const cat = categories.find((c) => c.key === suggestion.category_key);
  return cat ? cat.label : `Cuenta ${suggestion.account_code}`;
}

export default function MovementCard({ tx, suggestion, categories, onTap }) {
  const payrollPayment = tx.category === "nominas" && tx.status === "pending";
  const meta = payrollPayment ? { label: "Pago de nómina · Sin conciliar", cls: STATUS_META.pending.cls } : (STATUS_META[tx.status] || STATUS_META.pending);
  const showSugg = tx.status === "pending" && !payrollPayment && suggestion;
  const catLabel =
    tx.status === "classified"
      ? suggestionLabel({ category_key: tx.classified_category, account_code: tx.classified_account }, categories)
      : "";
  return (
    <button
      data-testid={`mcard-${tx.transaction_id}`}
      onClick={() => onTap(tx)}
      className="w-full text-left bg-white border border-slate-200 rounded-2xl px-3.5 py-3 min-h-[44px]"
    >
      <div className="flex items-start justify-between gap-3">
        <p className="flex-1 min-w-0 text-sm font-medium text-slate-900 truncate">{tx.description}</p>
        <p className={`font-mono text-[15px] font-semibold whitespace-nowrap tabular-nums ${tx.amount < 0 ? "text-rose-600" : "text-emerald-600"}`}>
          {formatSignedCurrency(tx.amount)}
        </p>
      </div>
      <div className="mt-1.5 flex items-center gap-2 min-w-0">
        <span className="font-mono text-[11px] text-slate-400">{formatDateShort(tx.date)}</span>
        <Badge variant="secondary" className={meta.cls}>{meta.label}</Badge>
        {catLabel && <span className="text-[11px] text-slate-500 truncate min-w-0">{catLabel}</span>}
        {tx.status === "reconciled" && (
          <span className="text-[11px] text-slate-500 truncate min-w-0">Conciliado con factura</span>
        )}
      </div>
      {showSugg && (
        <div
          data-testid={`msugg-${tx.transaction_id}`}
          className="mt-2 flex items-center gap-1.5 bg-violet-50 border border-violet-200 rounded-xl px-2.5 py-2"
        >
          {suggestion.source === "ai" ? (
            <Sparkles className="w-3.5 h-3.5 text-violet-600 shrink-0" strokeWidth={1.5} />
          ) : (
            <Workflow className="w-3.5 h-3.5 text-violet-600 shrink-0" strokeWidth={1.5} />
          )}
          <span className="min-w-0 truncate text-[11.5px] text-violet-800">
            <span className="font-semibold">{suggestion.source === "ai" ? "Sugerencia IA" : "Regla"}</span>
            {" · "}{suggestionLabel(suggestion, categories)}
            {suggestion.source === "ai" && suggestion.confidence != null && ` (${confidenceLabel(suggestion.confidence)})`}
          </span>
        </div>
      )}
    </button>
  );
}
